import axios from "axios";
import { getBackendUrl } from "../config";

const api = axios.create({
	baseURL: getBackendUrl(),
	withCredentials: true,
});

// Set Authorization header eagerly from localStorage so the first requests
// made by child components don't go out without a token (race with useEffect).
const _token = localStorage.getItem("token");
if (_token) {
	try {
		api.defaults.headers.Authorization = `Bearer ${JSON.parse(_token)}`;
	} catch (_) {}
}

export default api;
